// extracted by mini-css-extract-plugin
export default {"starsWrapper":"StartsUser_starsWrapper__SLAte","starsWrapper_big":"StartsUser_starsWrapper_big__qIPB+","reviews":"StartsUser_reviews__MZ9k0"};